function resizeTextarea(target) {
  // Сохраняем текущую позицию скролла
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  target.style.height = '';

  if(target.scrollHeight > 120){
    target.style.height = target.scrollHeight + 'px';
  }

  // Восстанавливаем позицию скролла
  window.scrollTo(0, scrollTop);
}

export function textareaHeight() {

  // Меняет высоту textarea, вместо скролла
  var elements = document.getElementsByTagName('textarea');
  for(var i = 0; i < elements.length; i++){
    resizeTextarea(elements[i]);

    elements[i].addEventListener('keyup', function(e){
      resizeTextarea(e.target);
    });
  };
}